import type { EventMergeId } from "./Tracking";
import type { TrackingLabels } from "./TrackingLabels";
import { misc } from "@otto-ec/global-resources/misc";
import tracker from "./Tracker";
import { log } from "./log";

let eventMergeId: EventMergeId | undefined;

export function createEventMergeId() {
  if (eventMergeId) {
    console.warn("EventMergeId already defined, it is overwritten", { previous: eventMergeId });
  }
  eventMergeId = misc.guid();
  log.debug("eventMergeId created", eventMergeId);
  return eventMergeId;
}

export function deleteEventMergeId(): EventMergeId | undefined {
  const tmp = eventMergeId;
  eventMergeId = undefined;
  if (tmp) {
    log.debug("eventMergeId deleted", tmp);
  }
  return tmp;
}

export function submitEventTracking(tracking: Partial<TrackingLabels>, eventMergeId?: string) {
  if (eventMergeId) {
    tracker.addToEvent(tracking, eventMergeId);
  } else {
    tracker.submitEvent(tracking);
  }
}
